<template>
  <div>
    <JyDialog :visible.sync="visible" :title="viewTitle" max-width="1000px" ref="viewDialog" moveable :activatedLoad="getData">
      <el-form label-width="100px" size="small" v-loading="viewLoading" class="view-form">
        <el-row type="flex" class="flex-wrap">
          <form-item label="分类" fill="4">
            <span>{{ viewData.catename }}</span>
          </form-item>
          <form-item label="标题" fill="4">
            <span>{{ viewData.title }}</span>
          </form-item>
          <form-item label="选项" fill="4">
            <div>
              <JyBadge :type="viewData.istop ? 'success' : ''" class="mr-2">{{ viewData.istop ? '置顶' : '未置顶' }}</JyBadge>
              <JyBadge v-if="viewData.isfocus" :type="viewData.isfocus ? 'success' : ''" class="mr-2">{{ viewData.isfocus ? '图片新闻' : '' }}</JyBadge>
              <JyBadge v-if="viewData.needip" :type="viewData.needip ? 'success' : ''">{{ viewData.needip ? '仅授权IP访问' : '' }}</JyBadge>
              <JyBadge v-if="viewData.othertop" :type="viewData.othertop ? 'success' : ''">{{ viewData.othertop ? '置顶其他' : '' }}</JyBadge>
            </div>
          </form-item>
          <form-item label="来源" fill="4">
            <span>{{ viewData.source }}</span>
          </form-item>
          <form-item label="外部链接" fill="4">
            <span>{{ viewData.outurl }}</span>
          </form-item>
          <form-item label="审稿人" fill="4">
            <span>{{ viewData.sgr }}</span>
          </form-item>
          <form-item label="发布人" fill="4">
            <span>{{ viewData.createusername }}</span>
          </form-item>
          <form-item label="发布时间" fill="4">
            <span>{{ viewData.createtime }}</span>
          </form-item>
          <form-item label="题图" fill="2">
            <span><img v-if="viewData.pic" :src="rootPath + viewData.pic" style="height:5rem;"></span>
          </form-item>
          <form-item label="视频" fill="2">
            <div>
              <video v-if="viewData.video1" :src="rootPath + viewData.video1" class="w-100" controls="controls">
              </video>
              <video v-if="viewData.video2" :src="viewData.video2" class="w-100" controls="controls">
              </video>
              <div v-if="viewData.video3" v-html="viewData.video3" class="w-100">
              </div>
            </div>
          </form-item>
          <!-- <form-item label="摘要" fill="4">
            <span>{{ viewData.summary }}</span>
          </form-item> -->
          <form-item label="介绍" fill="4">
            <span v-html="viewData.content"></span>
          </form-item>
          <form-item v-if="viewData.files" label="附件" fill="4">
            <div>
              <ul>
                <li v-for="(item, index) in viewData.files.split(',')" :key="index">
                  <a :href="rootPath + item" download>{{ item }}</a>
                </li>
              </ul>
            </div>
          </form-item>
        </el-row>
      </el-form>
      <div slot="footer">
        <JyButton type="secondary" icon="times" @click="doClose">关闭</JyButton>
      </div>
    </JyDialog>
  </div>
</template>

<script>
import tools from 'jyutils/tools';
export default {
  name: 'NewsView',
  components: {  },
  mixins: [tools],
  props: {
    newsid: String,
    news: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      visible: false,
      viewTitle: '',
      viewData: {},
      viewLoading: false
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.getData();
      }
    }
  },
  methods: {
    show(flag) {
      this.visible = flag ? true : false;
    },
    getData() {
      this.viewLoading = true;
      if (this.newsid) {
        this.doGet({
          url: 'sys/news/getById/'+ this.newsid,
          okcb: (json) => {
            this.viewData = json;
            this.viewTitle = '查看 - ' + this.viewData.title;
          },
          cb: () => {
            this.viewLoading = false;
          }
        });
      } else {
        this.viewData = this.news;
        this.viewTitle = '查看 - ' + this.viewData.title;
        this.viewLoading = false;
      }
    },
    doClose() {
      this.$refs.viewDialog.handleClose();
    }
  }
}
</script>